const openCartMapper = require('../globalheader/atmmapper/open-cart-mapper');

module.exports = function OpenClosePanel($timeout, $state, shopPageStateService, breakpointsService, browserWindowService, animationsService, featureService, panelOverride, trolleyService, atmService) {
    /// <summary>
    /// The open/hide panel directive hides or open the panel when clicked
    /// </summary>
    /// <returns type=""></returns>
    return {
        restrict: 'A',
        scope: true,
        transclude: true,
        link(scope, element, attrs) {
            const transitionDuration = 800;
            const invokeApply = true;
            const direction = attrs.wowOpenClosePanel;
            const button = element.find('.openClosePanel');
            const srtext = attrs.wowOpenClosePanelSrText;
            const isHomepageEnabled = featureService.isEnabled(featureService.features.homepageOnSmallFormat);
            const bodyContainer = element.parents('.body-container');
            scope.showLeftContent = true;
            scope.headerText = attrs.wowOpenClosePanelSrText;
            scope.panelOverride = panelOverride;
            scope.isOpen = true;

            function closePanel() {
                bodyContainer.removeClass(direction + '-panel-open');
                bodyContainer.addClass(direction + '-panel-is-closing');

                element.addClass('closed');
                button.addClass('closed');
                scope.srText = `Expand ${srtext}`;
                scope.isOpen = false;
                panelOverride.isOpen = false;
                $timeout(function () { // when transition end (can't use 'transitionend' old browsers)
                    if (element.hasClass('closed')) {
                        element.children().not('.openClosePanel').children().addClass('u-visibilityHidden');
                        bodyContainer.addClass(direction + '-panel-close').removeClass(direction + '-panel-is-closing');
                    }
                }, transitionDuration, invokeApply);
            }

            function openPanel() {
                bodyContainer.removeClass(direction + '-panel-close').addClass(direction + '-panel-is-openning');

                if (direction === 'left' && shopPageStateService.disabledPanel.left) {
                    return;
                }

                $timeout(function () {
                    bodyContainer.removeClass(direction + '-panel-is-openning');
                }, transitionDuration, invokeApply);

                bodyContainer.addClass(direction + '-panel-open');
                element.children().not('.openClosePanel').children().removeClass('u-visibilityHidden');
                element.removeClass('closed');
                button.removeClass('closed');
                scope.srText = `Collapse ${srtext}`;
                scope.isOpen = true;
                panelOverride.isOpen = true;
            }


            function hideButton() {
                button.hide();
            }

            function showButton() {
                button.show();
            }

            scope.$watch(function () {
                    return shopPageStateService.panels[direction];
                },
                function (newVal) {
                    if (newVal) {
                        openPanel();
                    } else {
                        closePanel();
                    }
                }
            );

            function reset() {
                shopPageStateService.reset();
                if (shopPageStateService.panels[direction]) {
                    openPanel();
                } else {
                    closePanel();
                }
            }

            function disableLeftPanel() {
                shopPageStateService.closeLeftPanel();
                shopPageStateService.disabledPanel.left = true;
                shopPageStateService.panels.left = false;
                if (direction === 'left') {
                    hideButton();
                    closePanel();
                }
            }

            function showLeftPanel() {
                shopPageStateService.disabledPanel.left = false;
                if (direction === 'left') {
                    showButton();
                    reset();
                }
            }

            function leftPanelHidden(state) {
                return breakpointsService.isInSmallFormat
                    ? shopPageStateService.sfhiddenLeftPanelState.indexOf(state) >= 0
                    : shopPageStateService.lfhiddenLeftPanelState.indexOf(state) >= 0;
            }

            // check if any panels are disabled and reset them if not
            function resetPanels() {
                if (!shopPageStateService.disabledPanel.left) {
                    if (leftPanelHidden($state.current.name)) {
                        disableLeftPanel();
                    } else {
                        reset();
                    }
                } else if (!leftPanelHidden($state.current.name)) {
                    showLeftPanel();
                }

                //This resets the forsm when resting from small format to med/large format thendisabled left panels.
                setTimeout(function () {
                    reset();
                    if (direction === 'left' && shopPageStateService.disabledPanel.left) {
                        shopPageStateService.closeLeftPanel();
                        hideButton();
                        closePanel();
                    }
                });
            }

            scope.$watch(function () { return breakpointsService.currentFormat; }, function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    resetPanels();
                }
            });

            scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
                if (direction === 'left' && leftPanelHidden(toState.name)) {
                    disableLeftPanel();
                } else if (toState.name !== fromState.name && direction === 'left' && leftPanelHidden(fromState.name)) {
                    showLeftPanel();
                }
            });

            scope.$on('mobileStorePickerPanelOverlayClose', () => resetPanels());

            scope.togglePanel = function (overridePanel = '') {

                const openClosePanel = () => {
                    if (!shopPageStateService.isPanelsAnimating) {
                        shopPageStateService.isPanelsAnimating = true;
                        shopPageStateService.togglePanel(direction);
                        if (isHomepageEnabled) {
                            shopPageStateService.changeStateOnToggle(direction, 'close', 'checkout.confirmation', 'root');
                        } else {
                            shopPageStateService.changeStateOnToggle(direction, 'close', 'checkout.confirmation', 'shop.browse');
                        }
                        if (shopPageStateService.panels && shopPageStateService.panels.right === true) {
                            atmService.push(trolleyService, openCartMapper, false, 'header');
                        }
                        setTimeout(function () { shopPageStateService.isPanelsAnimating = false; }, transitionDuration);
                    }
                };

                if (panelOverride.panel !== overridePanel && scope.isOpen) {
                    openClosePanel();
                    $timeout(() => {
                        panelOverride.panel = overridePanel || '';
                        openClosePanel();
                    }, transitionDuration);
                    return;
                }

                panelOverride.panel = overridePanel;
                panelOverride.isOpen = !scope.isOpen;
                openClosePanel();
            };

            //function call of work.
            scope.srText = `Collapse ${srtext}`;
            button.addClass(`openClosePanel--${direction}`);

            browserWindowService.init();
            shopPageStateService.initSidePanels();
            resetPanels();
        },
        template: require('./openclosepanel-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/openclosepanels/openclosepanel-directives.js
 **/